// extracted by mini-css-extract-plugin
export var pool = "style-module--pool--1tnWA";
export var poolTicker = "style-module--poolTicker--1mTim";
export var pulse = "style-module--pulse--ajyzv";
export var poolItem = "style-module--poolItem--1RcW0";
export var poolLabel = "style-module--poolLabel--3qUMM";
export var poolValue = "style-module--poolValue--4BrOb";